// extracted by mini-css-extract-plugin
module.exports = {"loader__wrap":"styles_loader__wrap__2zx9F"};